import { api } from "../../utils/api";
import { encodedURI, removeEmptyValues } from "../../utils/common";
import { endpoints } from "../../utils/endpoints";
import { updateKyc } from "./kycSlice";
import { updateCommonData } from "../../redux/commonSlice";
import Alert from "../../components/dialog/Alert";
import { updateGlobalLoader } from "../../components/backdrop/backdropSlice";



export const getListing = () => {
  return (dispatch, getState) => {
    const { limit, page, filters } = getState().kycSlice;
    const { userIds, ...result } = filters;
    const filterData = encodedURI(removeEmptyValues(result));
    api.getApiCall(
      endpoints.getKyc,
      `?limit=${limit}&offset=${page * limit}&filter=${filterData}`,
      (respData) => {
        dispatch(updateKyc({ listing: respData.data.result.data, totalCount: respData.data.result.count, totalPages: respData.data.result.count }));

      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};
export const updateKycDocStatus = (payload) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.putApiCall(
      endpoints.updateKycDocStatus, payload,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          dispatch(updateKyc({
            limit: 10,
            page: 0,
            totalCount: 0,
            totalPages: 0,
            listing: []
          }))
          dispatch(getListing());
          dispatch(updateCommonData({
            message: "Updated Successfully!",
            title: "",
            img: "/success.png",
            status: true
          }));
        }
      },
      (errors) => {
        dispatch(updateGlobalLoader(false));
        let { data } = errors;
        Alert(2, data?.msg);
      }
    );
  };
};

export const userkycDetails = (payload) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.putApiCall(
      endpoints.userkycDetails, payload,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          dispatch(updateKyc({
            limit: 10,
            page: 0,
            totalCount: 0,
            totalPages: 0,
            listing: []
          }))
          dispatch(getListing());
          dispatch(updateCommonData({
            message: "Updated Successfully!",
            title: "",
            img: "/success.png",
            status: true
          }));
        }
      },
      (errors) => {
        dispatch(updateGlobalLoader(false));
        let { data } = errors;
        Alert(2, data?.msg);
      }
    );
  };
};

